export default "__VITE_ASSET__00a560a1__"